// Neeche ka fixed navigation: Home / Leads / Appointments / Settings.
//
// `active` = jis page pe ye footer laga hai ("home" agent page pe, "leads"
// /leads page pe, "appointments" /pounce-appointments pe). Us tab pe dobara
// tap karne se page upar scroll hota hai;
// kisi aur tab pe tap us page pe le jaata hai.
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import usePounceAccess, { POUNCE_LOCK_MESSAGE } from "../../../hooks/usePounceAccess";
import styles from "./PounceFooterNav.module.css";
import { HomeIcon, LeadsIcon, AppointmentsIcon, IntegrationsIcon, SettingsIcon } from "./PounceFooterIcons";

const PounceFooterNav = ({ agentId, active = "home" }) => {
  const navigate = useNavigate();
  const [activePounceTab, setActivePounceTab] = useState(active);
  const { canViewLeads, canViewAppointments, canEdit } = usePounceAccess();
  // Wahi permission, doosra naam: is file me kabhi "canViewCallLogs" likha gaya
  // aur define nahi tha (build toot gaya). Dono naam yahin bane rahen.
  const canViewCallLogs = canViewLeads;
  // Band tab: dhundhla, tap pe kuch nahi.
  const lock = (allowed) =>
    allowed ? {} : { disabled: true, title: POUNCE_LOCK_MESSAGE, style: { opacity: 0.45, cursor: "not-allowed" } };

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className={styles.pounceFooter}>
      <button
        type="button"
        className={`${styles.pounceFooterItem} ${activePounceTab === "home" ? styles.pounceFooterActive : ""}`}
        onClick={() => {
          setActivePounceTab("home");
          if (active === "home") {
            // Pehle se agent ke home pe ho → dashboard (saare agents).
            navigate("/dashboard");
          } else {
            // Leads / Appointments se → Pounce agent ka home, jahan se shuru hue the.
            navigate("/fast-agent-detail", { state: { agentId, isPounce: true } });
          }
        }}
      >
        <HomeIcon />
        <span>Home</span>
      </button>
      {/* Team: jis page ki permission nahi, uska tab nahi (server bhi 403 deta hai). */}
      {canViewCallLogs && (
      <button
        type="button"
        className={`${styles.pounceFooterItem} ${activePounceTab === "leads" ? styles.pounceFooterActive : ""}`}
        {...lock(canViewLeads)}
        onClick={() => {
          setActivePounceTab("leads");
          if (active === "leads") {
            scrollToTop();
          } else {
            navigate("/leads");
          }
        }}
      >
        <LeadsIcon />

        <span>Leads</span>
      </button>
      )}
      {canViewAppointments && (
      <button
        type="button"
        className={`${styles.pounceFooterItem} ${activePounceTab === "appointments" ? styles.pounceFooterActive : ""}`}
        {...lock(canViewAppointments)}
        onClick={() => {
          setActivePounceTab("appointments");
          // Detail page (/pounce-appointments/:id) pe bhi ye tab chuna hota
          // hai — wahan se tap list pe le jaata hai, sirf list pe hi scroll.
          if (window.location.pathname === "/pounce-appointments") {
            scrollToTop();
          } else {
            navigate("/pounce-appointments");
          }
        }}
      >
        <AppointmentsIcon />

        <span>Appointments</span>
      </button>
      )}
      {/* Receptionist wali hi Integrations screen, par sirf MCP (mcpOnly). */}
      <button
        type="button"
        className={`${styles.pounceFooterItem} ${activePounceTab === "integrations" ? styles.pounceFooterActive : ""}`}
        {...lock(canEdit)}
        onClick={() => {
          setActivePounceTab("integrations");
          navigate("/integrations", {
            state: {
              agentId: agentId || sessionStorage.getItem("SelectAgentId") || null,
              mcpOnly: true,
            },
          });
        }}
      >
        <IntegrationsIcon />
        <span>Integrations</span>
      </button>
      <button
        type="button"
        className={`${styles.pounceFooterItem} ${activePounceTab === "settings" ? styles.pounceFooterActive : ""}`}
        {...lock(canEdit)}
        onClick={() => {
          setActivePounceTab("settings");
          // Settings hub; Calling Settings (/call-setting) opens from inside it.
          if (active === "settings") {
            scrollToTop();
          } else {
            navigate("/outbound-settings");
          }
        }}
      >
        <SettingsIcon />

        <span>Settings</span>
      </button>
    </footer>
  );
};

export default PounceFooterNav;
